import * as Immutable from 'immutable';
import { useSelector, useDispatch } from 'react-redux';
import { UserFlags } from '@ordermentum/ui-types';
import { fetchFlagsAsync } from '../redux/flags';

type FlagState = {
  data: UserFlags;
  loading: boolean;
  error: any;
};

export const useFlags = (
  flags: string[],
  context: any = {}
): UserFlags | undefined => {
  const dispatch = useDispatch();
  const flagData = useSelector<
    {
      flags: FlagState | Immutable.Map<keyof FlagState, any>;
    },
    UserFlags
  >(state => {
    if (!state.flags) {
      return {};
    }
    if (Immutable.Map.isMap(state.flags)) {
      // @ts-expect-error mixed types
      return state.flags.get('data')?.toJS() ?? {};
    }
    // @ts-expect-error mixed types
    return state.flags.data;
  });
  const userId = useSelector<
    {
      profile:
        | Immutable.Map<'data', { id: string }>
        | { data: { userId: string } };
    },
    string | undefined
  >(state => {
    try {
      if (Immutable.Map.isMap(state.profile)) {
        // @ts-expect-error mixed types
        return state.profile.getIn(['data', 'userId'])?.toJS() ?? '';
      }
      // @ts-expect-error mixed types
      return state.profile?.data?.userId;
    } catch (error) {
      // do nothing
    }
    return undefined;
  });

  const unknownFlags = flags.filter(flag => flagData[flag] === undefined);

  if (unknownFlags.length) {
    fetchFlagsAsync(unknownFlags, {
      userId,
      ...context,
    })(
      // @ts-expect-error
      dispatch
    );
  }
  return flagData;
};
